export default __webpack_public_path__ + "static/media/car.dfa175a2.png";